export default {
  title: 'Forgot password',
  rememberText: 'Find your password',
  rememberLinkText: 'Log in now',
  sendemail: {
    labelText: 'A verification link has been sent to your email.',
    remindText:
      'The activation email has been sent to you. The email is valid for 24 hours. Please click the verification link in the email to activate your account.',
    checkButtonText: 'Check Your Mailbox',
    homeButtonText: 'Return',
  },
  form: {
    mail: {
      placeHolder: 'Please enter your email address',
      required: 'Email Address cannot be empty.',
      formatVeryfy: 'Please enter a valid email address',
    },
    code: {
      required: 'The verification code cannot be empty',
    },
    submitText: 'Find password',
  },
}
